import clsx from "clsx";

export default function Badge({
  count,
  inline,
  isHeader,
}: {
  count: number;
  inline?: boolean;
  isHeader?: boolean;
}) {
  const baseClassName = [
    inline ? undefined : "absolute -right-2 -top-2",
    "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2",
    isHeader ? "border-[--color500]" : "border-white dark:border-gray-600",
    "bg-red-500 dark:bg-red-700",
    "text-[11px] font-medium text-white dark:text-gray-200",
  ];
  return (
    <>
      {!inline && <div data-testid="badge" className={clsx(baseClassName, "animate-ping")} />}
      <div data-testid="badge" className={clsx(baseClassName)}>
        {count}
      </div>
    </>
  );
}
